<script>
import MessagesList from './MessagesList.vue'
import MessagesNew from './MessagesNew.vue'
import { mapGetters } from '../store'

export default {
    name: 'Nav',
    components: {
        MessagesList,
        MessagesNew
    },
    computed: {
        ...mapGetters(['userResource']),
        isSuperuser() {
            return this.$store.getters.isSuperuser
        },
        hasCompanies() {
            return this.companyResources && this.companyResources.length > 0
        },
        unreadMessageResources() {
            return []
        },
        showMessagesSidebar() {
            return this.$store.getters.showMessagesSidebar
        }
    },
    watch: {
        showMessagesSidebar() {
            this.$refs.messages.loadRecents()
        },
        async userResource() {
            this.developerProfileResource = await this.userResource.getProfile()
        }
    },
    data() {
        return {
            loading: true,
            hasScrolled: false,
            developerProfileResource: null,
            companyResources: [],
            unreadMessagesCount: 0
        }
    },
    methods: {
        getClasses() {
            let classes = ['main-nav']

            if (this.$store.getters.navIsClear && !this.hasScrolled) {
                classes.push('clear')
            }

            return classes
        },
        async toggleMessagesSidebar() {
            this.$store.commit('toggleMessagesSidebar')
            await this.$refs.messages.getMessages()
        },
        hideMessagesSidebar() {
            this.$store.commit('hideMessagesSidebar')
        }
    },
    async mounted() {
        if(this.$store.getters.userId) {
            this.companyResources = await this.$store.dispatch('getUserCompanies')
            await this.$refs.messages.getMessages()
        }

        this.loading = false

        document.addEventListener('scroll', (e) => {
            this.hasScrolled = window.scrollY > this.$store.getters.clearNavMaxScrollY
        })
    },
}
</script>

<template>
    <div>
        <b-navbar type="dark" variant="dark" toggleable="lg" :class="getClasses()">
            <b-navbar-toggle target="nav-collapse">
                <template #default="{ expanded }">
                    <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
                    <b-icon v-else icon="chevron-bar-down"></b-icon>
                </template>
            </b-navbar-toggle>
            <b-navbar-brand class="logo-text"><router-link :to="{ name: 'home' }">Node<strong>Jobs</strong></router-link></b-navbar-brand>
            <b-collapse is-nav id="nav-collapse">
                <b-navbar-nav class="ml-auto" v-if="!loading">

                    <b-nav-item :to="{ name: 'recruitHome', params: { companyId: companyResources[0].id } }" v-if="hasCompanies"><b-icon icon="search"></b-icon> Hire Developers</b-nav-item>

                    <b-nav-item v-if="userResource" @click="toggleMessagesSidebar"><b-icon icon="envelope"></b-icon> Messages <b-badge variant="danger" pill v-if="unreadMessagesCount > 0">{{ unreadMessagesCount }}</b-badge></b-nav-item>
                    <b-nav-item v-else :to="{ name: 'signupDeveloper' }">Create a Developer Profile</b-nav-item>

                    <b-nav-item-dropdown text="Lang" class="ml-auto" right  v-if="userResource">
                        <template slot="button-content">
                            <b-icon icon="person-fill"></b-icon> {{ userResource.toString() }}
                        </template>

                        <b-dropdown-header>Account</b-dropdown-header>
                        <b-dropdown-item :to="{ name: 'settingsGeneral' }" v-if="developerProfileResource">Settings</b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'settingsDeveloperProfile' }" v-if="developerProfileResource">Edit Profile</b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'settingsApps' }" v-if="developerProfileResource">Applications</b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'settingsChangePassword' }">Change Password</b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'logout' }">Logout</b-dropdown-item>

                        <div v-if="hasCompanies">
                            <b-dropdown-divider />
                            <b-dropdown-header>Companies</b-dropdown-header>
                            <span v-for="(companyResource, i) in companyResources" :key="i">
                                <b-dropdown-item :to="{ name: 'recruitHome', params: { companyId: companyResource.id } }">{{ companyResource }}</b-dropdown-item>
                            </span>
                        </div>
                    </b-nav-item-dropdown>

                    <b-nav-item :to="{ name: 'signupCompany' }" v-if="!userResource">Hire Developers</b-nav-item>
                    <b-nav-item :to="{ name: 'login' }" v-if="!userResource">Login</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <!-- Messages -->
        <b-sidebar :visible="showMessagesSidebar" @hidden="hideMessagesSidebar" title="Messages" width="700px" right shadow>
            <messages-list v-model="unreadMessagesCount" :userResource="userResource" v-if="userResource" ref="messages" />
        </b-sidebar>
        <messages-new />
    </div>
</template>

<style lang="scss" scoped>
a.router-link-exact-active {
    color: #fff !important;
}

.main-nav {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    //background: linear-gradient(135deg, #333f8c 0%, #3a96cc 100%);
    background-color: #2167ae !important;
    transition: all 0.5s ease;

    a {
        color: #fff;

        &:hover {
            text-decoration: none;
        }
    }
}

.main-nav.clear {
    background: transparent !important;
    transition: all 0.5s ease;
}

.logo-text {
    font-family: 'Ubuntu', sans-serif;
    font-weight: 700;
    padding-left: 25px;
    background-image: url(../assets/img/nodejobs-logo.png);
    background-repeat: no-repeat;
    background-size: 19.3px 22px;
    background-position-y: 9px;
}

@media (max-width: 768px) {
    .main-nav.clear {
        background: #2c4693 !important;
    }
}
</style>
